/* eslint camelcase: 0 */
import { UpstreamGatewayBase } from './base'
import { toNewsProps } from './translator/news'
import { toUpstreamQueryProps, toQueryProps } from './translator/query'
import { GetNews, FetchNews } from '@/infrastructure/network/Upstream/requests/news'
import { INewsProps, EmptyNewsPropsFactory } from '@/entities/Upstream/News'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'

export default class News extends UpstreamGatewayBase {
  async GetNews(id: string): Promise<INewsProps> {
    const { news } = await this.apiClient.request(new GetNews(id))
    return news ? toNewsProps(news) : EmptyNewsPropsFactory()
  }

  async FetchNews(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchNews(toUpstreamQueryProps(query)))
    return EmptyResponsePropsFactory({
      items: response.news.map((prop) => toNewsProps(prop)),
      query: { ...query, ...toQueryProps(response.query) }
    })
  }
}
